module.exports = __webpack_public_path__ + "img/home_icon_2.fc423b17.png";